/* eslint-disable react/prop-types */
/*
Author: Ayi R
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';

import AccountGroupScreen from '@/screens/setting/account-group/AccountGroupScreen';
import AccountGroupFormScreen from '@/screens/setting/account-group/AccountGroupFormScreen';

const Stack = createStackNavigator();

const AccountGroupNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="AccountGroupScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="AccountGroupScreen"
        component={AccountGroupScreen}
        options={() => ({
          // headerRight (incl. the mobile "Add") is owned by AccountGroupScreen
          // so Add can go through openChild and preserve the list on return.
          title: setTitleHeader('Account Group'),
        })}
      />
      <Stack.Screen
        name="AccountGroupFormScreen"
        component={AccountGroupFormScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Add Account Group';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          return {
            title: setTitleHeader(title),
            // navigate() to the list (not pop) so back survives a browser
            // refresh, where the list isn't in the fresh stack.
            headerLeft: () => (
              <BackButton
                {...props}
                onPress={() => props.navigation.navigate('AccountGroupScreen')}
              />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default AccountGroupNavigator;
